import _camelCase from 'lodash/camelCase';
import _mapKeys from 'lodash/mapKeys';
import { CollectMethod, Item, Pickup } from '../types/common';
import { Currency } from '../types/payment';
import currency from './currency';
import Logger from './logger';

export const currentCountry = process.env.NEXT_PUBLIC_COUNTRY || 'HK';

export const trans: Record<string, string> = {
  en: 'English',
  'en-tw': 'English',
  'zh-tw': '繁體中文',
};

export const isSSR = typeof window === 'undefined';

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noop = (): void => {};

export const prefix = (locale: string, defaultLocale?: string): string =>
  locale && locale !== defaultLocale ? `/${locale}` : ``;

export const convertLocale = (lowerLocale: string): string => {
  if (lowerLocale.length === 2) return lowerLocale;
  const [lang, region] = lowerLocale.split('-');
  return `${lang}-${region.toUpperCase()}`;
};

export class SpaceshipApiError extends Error {
  public code: number | string;

  public constructor(code: number | string, message: string) {
    super(message);
    this.name = 'SpaceshipApiError';
    this.code = code;
    this.message = message;
  }
}

export const transformKeyToCamelCase = (object: Record<string, any>): Record<string, any> => {
  return _mapKeys(object, (_, key) => _camelCase(key));
};

export const getTrans = (obj: Record<string, string>, locale: string): string => {
  if (!obj) return '';
  const lang = locale.slice(0, 2);
  return obj[lang] || obj['en'];
};

export const parseTimeString = (timeString: string): Date => {
  const [h, m] = timeString.split(':');
  return new Date(0, 0, 0, parseInt(h), parseInt(m));
};

export const getBaseCountry = (): string => {
  // TODO: extend here to get default country
  return currentCountry;
};

export const setFixedScrollPosition = (fixed: boolean): void => {
  if (document) {
    document.body.classList.toggle('popover-open', fixed);
  }
};

export const getDiscountPrecentage = (total: Currency, discount?: Currency): number => {
  if (!discount) return 0;
  if (discount.currency !== total.currency) {
    Logger.error('[Helper] Discount currency does not match with total currency.');
    return 0;
  }

  const originalAmount = total.amount + discount.amount;
  const discountAmount = discount.amount;

  if (discountAmount >= originalAmount) {
    return 100;
  }

  const precentage = (discountAmount / originalAmount) * 100;
  return Math.round(precentage);
};

export const getOrderValue = (naturalAmount: Record<string, number> = {}): number => {
  // amounts inside naturalAmount are in HKD
  const { finalTotal, totalRate } = naturalAmount;
  if (!finalTotal && !totalRate) return 0;

  return Math.round(finalTotal || totalRate);
};

export const getCourier = (service: string): string => {
  const [courier] = service.split('-');
  return courier;
};

export const getCollectMethod = (pickup?: Pickup): CollectMethod | null => {
  const { type } = pickup || {};
  if (!type) {
    return null;
  } else if (type === 'SELF_PICKUP') {
    return CollectMethod.DROPOFF;
  } else {
    return CollectMethod.PICKUP;
  }
};

export const convertDocumentToItems = (description: string): Item[] => {
  if (!description) return [];
  return [
    {
      description,
      value: currency.convert(1, 'HKD'),
      qty: 1,
    },
  ];
};
